
"use client"

import Aos from "aos";
import { Minus } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import React from "react";


export const oneLinkProduct = {
  title: "کرید اونتوس مردانه",
  src: "/product/creed-aventus-for-man-edp",
  img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-01/aventus-100ml-bottle_3413e5f4-3eee-40b3-8451-2546a370ec5b-Photoroom (1) (1).png`
}
export const twoLinkProduct = {
  title: "گود گرل مشکی",
  src: "/product/carolina-herrera-good-girl-for-women-edp",
  img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-07-30/carolina-herrera-good-girl-eau-de-parfum-80ml_15239440_38169233_2048-Photoroom (1) (1).png`
}

export const dataLinkProduct = [
  {
    children: [
      {
        title: " باکارات رژ 540 سفید",
        src: "/product/maison-francis-kurkdjian-baccarat-rouge-540-for-women-and-men-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-13/1720885426197-295909316.png`
      },
      {
        title: "دیورهوم اینتنس",
        src: "/product/dior-homme-intense-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-09-18/dior%20homme%20intense%20for%20man%20edt.png`
      },
      {
        title: "لانکوم لا ویه است بله",
        src: "/product/lancome-la-vie-est-belle-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-09-03/lancome la vie est belle for women edp.png`
      },
      {
        title: "ژان پل گوتیه اسکندال",
        src: "/product/jean-paul-gaultier-scandal-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-07/Jean-Paul-Gaultier-Scandal-8435415059060-www.atrinstar.ir_-Photoroom (2) (2).png`
      },
      {
        title: "دیور ساواج",
        src: "/product/dior-sauvage-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-18/Y0685240_F068524009_E01_GHC-ezgif.com-webp-to-png-converter-Photoroom (1) (1).png`
      },
      {
        title: "مگاماره اورتو پاریسی",
        src: "/product/orto-parisi-megamare-for-women-and-man-parfum",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-09-27/orto-parisi-megamare (2) (1).jpg`
      },
    ],
    title: "دسته ۱"
  },
  {
    children: [
      {
        title: " باکارات رژ540 قرمز",
        src: "/product/maison-francis-kurkdjian-baccarat-rouge-540-for-women-and-men-extrait-de-parfum",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-13/1720885697534-689345180.png`
      },
      {
        title: "شنل بلو ادو پرفیوم",
        src: "/product/chanel-bleu-de-chanel-for-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-01/9539149398046-Photoroom (1) (1) (1).png`
      },
      {
        title: "لالیک مشکی انکر نویر",
        src: "/product/lalique-encre-noire-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-09-14/%C3%98%C2%A7%C3%98%C2%AF%C3%9A%C2%A9%C3%99%C2%84%C3%99%C2%86%20%C3%99%C2%84%C3%98%C2%A7%C3%99%C2%84%C3%9B%C2%8C%C3%9A%C2%A9%20%C3%99%C2%85%C3%98%C2%B4%C3%9A%C2%A9%C3%9B%C2%8C%20%C3%98%C2%A7%C3%99%C2%86%C3%9A%C2%A9%C3%98%C2%B1%20%C3%99%C2%86%C3%99%C2%88%C3%9B%C2%8C%C3%98%C2%B1.png`
      },

      {
        title: "پاکو رابان اینویکتوس",
        src: "/product/paco-rabanne-invictus-for-men-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-09-01/Untitled-design-79-Photoroom (1) (1) (1).png`
      },
      {
        title: "آنجلز شیر بای کیلیان",
        src: "/product/by-kilian-angels-share-women-and-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}images/2024-10-07/cocktail-intense-perfume-bottle-against-white-background+(1) (1).webp`
      },
      {
        title: "دیور ساواج الکسیر",
        src: "/product/dior-sauvage-elixir-for-man-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-22/Fragrance-World-Suave-Elixir-Man-Extrait-de-Parfum-80-ML-Photoroom (1) (2).png`
      },
    ],
    title: "دسته ۲"
  },
  {
    children: [
      {
        title: "هرمس تق هرمس (ادو تویلت)",
        src: "/product/hermes-terre-d-hermes-for-man-edt",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-8/1720457680254-761224247.png`
      },
      {
        title: "ویکتوریا سکرت بامبشل",
        src: "/product/victoria-secret-bombshell-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/0c4773dcfb668d58adb09b2ac44a6524-Photoroom (1) (2).png`
      },
      {
        title: "لالیک لامور زنانه",
        src: "/product/Lalique-L%E2%80%99Amour",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-4/1720102915293-317754891.png`
      },
      {
        title: "جورجیو آرمانی مای وی",
        src: "/product/giorgio-armani-my-way-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-08-03/giorgio-armani-my-way-eau-de-parfum-37230863646962-Photoroom (1) (1).png`
      },
      {
        title: "شیسیدو زن زنانه",
        src: "/product/shiseido-zen-for-women-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-7-6/1720272303023-694045909.png`
      },
      {
        title: "فلور نارکوتیک ایکس نیلهو",
        src: "/product/ex-nihilo-fleur-narcotique-for-women-and-men-edp",
        img: `${process.env.NEXT_PUBLIC_IMAGE_URL}static/2024-09-01/ex-nihilo-fleur-narcotique-fleur-narcotique-100ml (1)-Photoroom (1) (1).png`
      }
    ],
    title: "دسته ۳"
  }
]

export const allProductDetails = [
  {
    title: oneLinkProduct.title,
    src: oneLinkProduct.src,
    alt: oneLinkProduct.title,
    img: oneLinkProduct.img
  },
  {
    title: twoLinkProduct.title,
    src: twoLinkProduct.src,
    alt: twoLinkProduct.title,
    img: twoLinkProduct.img
  },
  ...dataLinkProduct.flatMap(category =>
    category.children.map(product => ({
      title: product?.title,
      src: product?.src,
      alt: product?.title,
      img: product?.img
    }))
  )
];


const MenuProducts = () => {

  React.useEffect(() => {
    Aos.init({
      duration: 1000,
      once: false
    });
  }, []);

  React.useEffect(() => {
    Aos.refresh();
  });


  return (
    <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
      <div className="flex w-full py-5 px-10 bg-main">
        {dataLinkProduct.map((item, idx) => {
          const time = idx * 200;
          return (
            <div
              data-aos="fade-zoom-in"
              data-aos-delay={`${time}`}
              key={idx}
              className="w-72 p-1 bg-white m-1 rounded-md"
            >
              {item.children.map((child, index) => (
                <Link
                  data-aos="fade-zoom-in"
                  data-aos-delay={`${index * 100 + time}`}
                  className="flex items-center text-sm my-2 hover:text-pink hover:mr-1 transition-all duration-300 hover:font-bold opacity-80"
                  key={child.title}
                  href={child.src}
                >
                  <Image src={child.img} alt={child.title} height={50} width={50} />
                  <Minus className="size-4 ml-1" /> {child.title}
                </Link>
              ))}
            </div>
          );
        })}
        <div className="w-52 text-center mx-auto">
          <Link
            className="p-1 bg-white m-1 rounded-md block"
            key={oneLinkProduct.title}
            data-aos="fade-zoom-in"
            data-aos-delay={1000}
            href={oneLinkProduct.src}
          >
            <Image
              className="rounded-full inline"
              height={160}
              width={160}
              src={oneLinkProduct.img}
              alt={oneLinkProduct.title}
            />
            <p className="text-sm text-text text-center">{oneLinkProduct.title}</p>
          </Link>
          <Link
            className="p-1 bg-white m-1 rounded-md block"
            key={twoLinkProduct.title}
            data-aos="fade-zoom-in"
            data-aos-delay={1100}
            href={twoLinkProduct.src}
          >
            <Image
              className="rounded-full inline"
              height={160}
              width={160}
              src={twoLinkProduct.img}
              alt={twoLinkProduct.title}
            />
            <p className="text-sm text-text text-center">{twoLinkProduct.title}</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MenuProducts;
